module.exports = __webpack_public_path__ + "img/9.7dcafe1a.jpg";